import { motion } from "framer-motion";

/**
 * Client Logo Wall — infinite marquee.
 * Add / remove logos here. `bg` = tiny padding hint (optional).
 */
export const CLIENTS = [
  {
    id: "shant",
    name: "Shant",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/p8332lb7_%D8%A7%D8%B2%D8%B1%D9%82%20%D8%A7%D8%B5%D9%81%D8%B1.webp",
  },
  {
    id: "karez",
    name: "Karez Lebanon",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/bsfewil9_%D9%84%D9%88%D9%83%D9%88%20%D9%83%D8%B1%D8%B2%20%D9%84%D8%A8%D9%86%D8%A7%D9%86%20%D9%85%D9%81%D8%B1%D8%BA.png",
  },
  {
    id: "newton",
    name: "Newton",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/d7xc9qtg_%D9%84%D9%88%D9%83%D9%88%20%D9%86%D9%8A%D9%88%D8%AA.webp",
  },
  {
    id: "alfakher",
    name: "Al Fakher",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/az3htb9v_logowhite.png",
  },
  {
    id: "lavender",
    name: "Lavender",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/ywcjzjys_lavender%20new%20logo_page-000111%D8%A7%D8%A8%D9%8A%D8%B6.webp",
  },
  {
    id: "artboard",
    name: "Client",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/jq7n1z9o_Artboard%201.png%20%D8%A7%D8%A8%D9%8A%D8%B6.png",
  },
  {
    id: "nabu",
    name: "Nabu",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/pg7lv08h_%D9%86%D8%A7%D8%A8%D9%88%20%D9%84%D9%88%D9%83%D9%88.png",
  },
  {
    id: "nwah",
    name: "NWAH",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/b8327ml9_%D9%84%D9%88%D9%83%D9%88%20%D9%86%D9%88%D8%A7%D9%87.png",
  },
  {
    id: "kinefill",
    name: "Kinefill",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/g7lzpwb8_kinefill%20png%20logo%20white.png",
  },
  {
    id: "starderm",
    name: "Starderm",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/2js9cb2a_starderm%20white.png",
  },
  {
    id: "almuhra",
    name: "Al-Muhra Clinic",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/npr3xchf_%D8%B9%D9%8A%D8%A7%D8%AF%D8%A9%20%D8%A7%D9%84%D9%85%D9%87%D8%B1%D8%A9%202.png",
  },
  {
    id: "dowakum",
    name: "Dowakum",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/sqhwds62_logo%20white.webp",
  },
  {
    id: "shantmarket",
    name: "Shant Market",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/giiw6pug_%D8%B4%D8%A7%D9%86%D8%AA%20%D9%85%D8%A7%D8%B1%D9%83%D8%AA%20%D9%84%D9%88%D9%83%D9%88.png",
  },
  {
    id: "isx",
    name: "Iraq Stock Exchange",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/zmgsnhwy_%D9%84%D9%88%D9%83%D9%88%20%D8%B3%D9%88%D9%82%20%D8%A7%D9%84%D8%B9%D8%B1%D8%A7%D9%82.png",
  },
  {
    id: "eshq",
    name: "Eshq Library",
    src: "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/xk3unose_%D9%84%D9%88%D9%83%D9%88%20%D8%B9%D9%84%D9%8A%D8%B4%D9%88.webp",
  },
];

export default function Clients() {
  // Split into two rows for opposing marquees
  const mid = Math.ceil(CLIENTS.length / 2);
  const row1 = [...CLIENTS.slice(0, mid), ...CLIENTS.slice(0, mid)];
  const row2 = [...CLIENTS.slice(mid), ...CLIENTS.slice(mid)];

  return (
    <section
      data-testid="clients-section"
      className="relative py-24 md:py-32 border-y border-white/5 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.9 }}
          className="flex items-center justify-between flex-wrap gap-4 mb-10 md:mb-14"
        >
          <div className="flex items-center">
            <span className="h-rule" />
            <span className="overline">Trusted by</span>
          </div>
          <div
            dir="rtl"
            className="font-arabic text-lg md:text-2xl font-bold text-white/85"
          >
            بعض العلامات التجارية التي عملت معها
          </div>
        </motion.div>
      </div>

      {/* Marquee rows */}
      <div className="relative space-y-8 md:space-y-12">
        {/* Fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 z-10 bg-gradient-to-r from-[#171717] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 z-10 bg-gradient-to-l from-[#171717] to-transparent" />

        {/* Row 1 → moves LEFT */}
        <div className="marquee-fast flex items-center gap-10 md:gap-16 whitespace-nowrap">
          {row1.map((c, i) => (
            <LogoTile key={`r1-${c.id}-${i}`} c={c} />
          ))}
        </div>

        {/* Row 2 → moves RIGHT */}
        <div className="marquee-reverse flex items-center gap-10 md:gap-16 whitespace-nowrap">
          {row2.map((c, i) => (
            <LogoTile key={`r2-${c.id}-${i}`} c={c} />
          ))}
        </div>
      </div>
    </section>
  );
}

function LogoTile({ c }) {
  return (
    <div
      data-testid={`client-logo-${c.id}`}
      className="shrink-0 h-32 md:h-40 lg:h-48 flex items-center justify-center group"
      title={c.name}
    >
      <img
        src={c.src}
        alt={c.name}
        className="h-full w-auto object-contain opacity-80 group-hover:opacity-100 transition-all duration-500"
        style={{ maxWidth: "320px", mixBlendMode: c.blend || "normal" }}
      />
    </div>
  );
}
